import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'loyaltic-scan-participate',
  templateUrl: './scan-participate.component.html',
  styleUrls: ['./scan-participate.component.scss']
})
export class ScanParticipateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
